/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResourceTypeDto } from './ResourceTypeDto';
import {
    ResourceTypeDtoFromJSON,
    ResourceTypeDtoFromJSONTyped,
    ResourceTypeDtoToJSON,
} from './ResourceTypeDto';

/**
 * 
 * @export
 * @interface ResourceTypesDto
 */
export interface ResourceTypesDto {
    /**
     * The available resource types.
     * @type {Array<ResourceTypeDto>}
     * @memberof ResourceTypesDto
     */
    items: Array<ResourceTypeDto>;
}

/**
 * Check if a given object implements the ResourceTypesDto interface.
 */
export function instanceOfResourceTypesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function ResourceTypesDtoFromJSON(json: any): ResourceTypesDto {
    return ResourceTypesDtoFromJSONTyped(json, false);
}

export function ResourceTypesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceTypesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ResourceTypeDtoFromJSON)),
    };
}

export function ResourceTypesDtoToJSON(value?: ResourceTypesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ResourceTypeDtoToJSON)),
    };
}

